var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-4 fill-height",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}}),_c('v-flex',{staticStyle:{"height":"calc(100vh - 132px)"},attrs:{"xs8":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }